<template>
  <div class="content">
    <Header title="评价查询"></Header>
    <NOdata
      v-if="
        (this.evaluateList && this.evaluateList.length == 0) ||
          this.evaluateList == '[]'
      "
      title="暂无教学评价~"
    ></NOdata>
    <div
      v-else
      class="grey-contain"
      v-for="(item, index) in evaluateList"
      :key="index"
    >
      <div style="width:calc(100% - 80px);">
        <p class="contain-txt">
          [{{ item.dataitem[0].kch }}]{{ item.dataitem[0].kcmc }}
        </p>
        <span class="contain-txt1">
          授课教师：[{{ item.dataitem[0].jgh }}]{{ item.dataitem[0].xm }}
        </span>
        <div class="contain-txt1">
          日期：{{ item.dataitem[0].mxrq == "" ? "无" : item.dataitem[0].mxrq }}
        </div>
        <van-row>
          <van-col span="8">
            <div class="contain-txt1">
              周次：{{ item.dataitem[0].zc == "" ? "无" : item.dataitem[0].zc }}
            </div>
          </van-col>
          <van-col span="8">
            <div class="contain-txt1">
              星期：{{ item.dataitem[0].xq == "" ? "无" : item.dataitem[0].xq }}
            </div>
          </van-col>
          <van-col span="8">
            <div class="contain-txt1">
              节次：{{ item.dataitem[0].jc == "" ? "无" : item.dataitem[0].jc }}
            </div>
          </van-col>
        </van-row>
      </div>
      <!-- 评价详情 @click="goCheck(item)" -->
      <div class="r_box">
        <span class="number">
          {{ item.dataitem[0].zpf == "" ? "0" : item.dataitem[0].zpf }}
        </span>
        <span class="grade">总评分</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "../../../utils/axios";

export default {
  data() {
    return {
      evaluateList: []
    };
  },
  methods: {
    // goCheck(e) {
    //   this.$router.push({
    //     path: "/gradeDetails",
    //     query: {
    //       batchId: e.batchId,
    //       evaluationCategoriesId: e.evaluationCategoriesId,
    //       courseId: e.courseId,
    //       teacherId: e.teacherId,
    //       noticeId: e.noticeId,
    //       schoolClassificationId: e.schoolClassificationId,
    //       teacherName: e.teacherName,
    //       teacherNumber: e.teacherNumber
    //     }
    //   });
    // },
    async getList() {
      const res = await Api.teachingEvaluated({
        batchId: this.$route.query.batchId
      });
      if (res.code == "0") {
        this.$toast.fail(res.errorMessage);
      } else {
        this.evaluateList = res.data[0].evaluationitem;
      }
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.content {
  padding-bottom: 80px;
}
.grey-contain {
  padding: 20px;
}
.grey-contain button {
  background-color: @attendance-background-color-1;
  padding: 11px 19px;
  border-radius: 3px;
  color: @attendance-color-3;
}
.delay-btn {
  position: absolute;
  bottom: 20px;
  width: 100%;
  text-align: center;
}
.delay-btn button {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
  padding: 11px 0;
  width: 90%;
  border-radius: 3px;
}
.r_box {
  width: 24%;
  height: 42px;
  float: right;
  background: url(../../../assets/images/bg_icon.png) center center no-repeat;
  background-size: 100%;
  /* margin: 20px 20px 0 0; */
  text-align: center;
}
.contain-txt {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.r_box span {
  display: block;
}
.r_box .number {
  color: @attendance-color-3;
  font-size: 18px;
  margin-top: 3px;
}
.r_box .grade {
  color: @attendance-color-3;
  font-size: 10px;
}
.page {
  width: 100%;
  background-color: #fff;
  position: fixed;
  bottom: 0;
}
.page ul {
  width: 90%;
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Evaluate1/searchResult.vue